<style>
.transition {
  animation-name: example;
  animation-duration: 0.8s;
}
@keyframes example {
  0% {
    opacity: 0;
  }
  05% {
    opacity: 0.05;
  }

  10% {
    opacity: 0.1;
  }
  15% {
    opacity: 0.15;
  }

  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }

  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<template>
  <div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="opcionesAvanzadas"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div
          class="modal-content color-scheme-dark"
          style="width: 100%; max-width: 100%"
        >
          <div class="modal-header faded smaller">
            <h5 class="text-success modal-title">
              Opciones extras del producto
            </h5>
            <br />
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="element-wrapper">
              <div>
                <select class="form-control form-control-sm" v-model="menu">
                  <option value="">Elija una de las opciones</option>
                  <option value="1">1. Descripción de la mercadería</option>
                  <option value="2">2. Empaque del proveedor</option>
                  <option value="3">3. Empaque de CEDIS</option>
                  <option value="4">4. Información de paletizado</option>
                  <option value="5">
                    5. Información de precios supermercado
                  </option>
                  <option value="6">6. Informacion de precios mayoreo</option>
                  <option value="7">7. Informacion del articulo</option>
                  <option value="8">8. Ubicación del producto en tienda</option>
                </select>
              </div>
            </div>
            <div class="element-wrapper">
              <!-- Area 1 de menu Descripción de la mercadería -->
              <div class="transition row" v-if="menu == '1'">
                <div class="col-4">
                  <label>Contenido neto</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="current.cont_neto"
                  />
                </div>
                <div class="col-4">
                  <label>Unidad medida cont. neto</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="current.uom_cont_neto"
                  >
                    <option value="FO">FLUID OUNCE (ONZA LIQUIDA)</option>
                    <option value="GA">GALON</option>
                    <option value="GH">HALF GALLON (MEDIO GALON)</option>
                    <option value="LT">LITRO</option>
                    <option value="PT">PINTA (EQ. A 1/8 GALON)</option>
                    <option value="PV">HALF PINT (MEDIA PINTA)</option>
                    <option value="QT">QUART (EQ. A 2 PINTAS)</option>
                    <option value="FT">FOOT (PIE)</option>
                    <option value="IN">INCH (PULGADA)'</option>
                    <option value="YD">YARDA</option>
                    <option value="EA">EACH (PIEZA)</option>
                    <option value="GR">GRAMOS</option>
                    <option value="LB">POUND (LIBRA</option>
                    <option value="OZ">OUNCE (ONZA)</option>
                    <option value="KG">KILOGRAMO</option>
                    <option value="CF">CUBIC FEET (PIE CUBICO)</option>
                    <option value="CM">CENTIMETRO</option>
                    <option value="ML">MILILITRO</option>
                  </select>
                </div>
                <div class="col-4">
                  <label>Marca</label>
                  <select
                    class="form-control"
                    autofocus="autofocus"
                    required
                    v-model="current.marca"
                    @input="$emit('input', $event.target.value)"
                  >
                    <option
                      v-for="(det, key) in marcas"
                      :value="det.id"
                      :key="key"
                    >
                      {{ det.nombre }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="transition row" v-if="menu == '2'">
                <div class="col-4">
                  <label>Barra de empaque proveedor</label>
                  <input
                    type="text"
                    v-model="current.barra_empaq_prov"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Cantidad por empaque de proveedor</label>
                  <input
                    type="number"
                    v-model="current.cant_empaq_prov"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Longitud de empaque proveedor (centimetro)</label>
                  <input
                    type="number"
                    v-model="current.longitud_empaq_cm_prov"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Ancho de empaque proveedor (centimetro)</label>
                  <input
                    type="number"
                    v-model="current.ancho_empaq_cm_prov"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Altura de empaque de proveedor (centimetro)</label>
                  <input
                    type="number"
                    v-model="current.altura_empaq_cm_prov"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Peso de empaque proveedor (Kilogramo)</label>
                  <input
                    type="number"
                    v-model="current.peso_empaq_kg_prov"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Unidades minimas para ordenar al proveedor</label>
                  <input
                    type="number"
                    v-model="current.cant_min_pedido_prov"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <br />
                  <label>Indicador RTD:&nbsp;</label>
                  <input
                    type="checkbox"
                    v-model="current.indicador_rtd"
                    class="form-control"
                  />
                </div>
              </div>

              <div class="transition row" v-if="menu == '3'">
                <div class="col-4">
                  <label>Barra empaque de CEDIS</label>
                  <input
                    type="text"
                    v-model="current.barra_empaq_cd"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Cantidad empaque de CEDIS</label>
                  <input
                    type="number"
                    v-model="current.cant_empaq_cd"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Longitud empaque CEDIS</label>
                  <input
                    type="number"
                    v-model="current.longitud_empaq_cm_cd"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <br />
                  <label>Ancho empaque CEDIS</label>
                  <input
                    type="number"
                    v-model="current.ancho_empaq_cm_cd"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <br />
                  <label>Altura empaque CEDIS</label>
                  <input
                    type="number"
                    v-model="current.altura_empaq_cm_cd"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <br />
                  <label>Peso empaque CEDIS</label>
                  <input
                    type="number"
                    v-model="current.peso_empaq_kg_cd"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="transition row" v-if="menu == '4'">
                <div class="col-3">
                  <label>Cantidad de cajas por cama/capa</label>
                  <input
                    type="number"
                    v-model="current.cant_cajas_por_cama"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <label>Cantidad de camas/capas por tarima</label>
                  <input
                    type="number"
                    v-model="current.cant_camas_por_Tarima"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <label>Factor de compresion: &nbsp;</label>
                  <select
                    v-model="current.factor_compresion"
                    class="form-control"
                  >
                    <option value="100">
                      Resistencia alta (estibar en la base)
                    </option>
                    <option value="50">
                      Resistencia media (no se estibe en la base)
                    </option>
                    <option value="0">
                      Resistencia baja (estibar hasta arriba)
                    </option>
                  </select>
                </div>
                <div class="col-3">
                  <label>Tipo de rotacion en CEDIS: &nbsp;</label>
                  <select
                    v-model="current.tipo_rotacion_cd"
                    class="form-control"
                  >
                    <option value="1">(1) - Normal - First in-First Out</option>
                    <option value="2">
                      (2) - Estricta (Strict) basada en fechas de caducidad
                    </option>
                  </select>
                </div>
              </div>
              <div class="transition row" v-if="menu == '5'">
                <div class="col-4">
                  <label>Costo unitario supermercado</label>
                  <input
                    type="number"
                    v-model="current.sup_costo_unitario"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Precio base por unidad supermercado</label>
                  <input
                    type="number"
                    v-model="current.sup_precio_base_unitario"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>UXC supermercado</label>
                  <input
                    type="text"
                    v-model="current.sup_uxc"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="transition row" v-if="menu == '6'">
                <div class="col-4">
                  <label>Costo unitario mayoreo</label>
                  <input
                    type="number"
                    v-model="current.may_costo_unitario"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Precio base unidad mayoreo</label>
                  <input
                    type="number"
                    v-model="current.may_precio_base_unitario"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>UXC mayoreo</label>
                  <input
                    type="text"
                    v-model="current.may_uxc"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="transition row" v-if="menu == '7'">
                <div class="col-4">
                  <label>Tipo de Articulo</label>
                  <select v-model="current.tipo_ingreso" class="form-control">
                    <option value="1">Compra en tienda</option>
                    <option value="2">Abstecido del CD</option>
                    <option value="3">In & out</option>
                    <option value="4">Temporada</option>
                  </select>
                </div>
                <div class="col-4">
                  <label>Registro sanitario</label>
                  <input
                    type="text"
                    v-model="current.registro_sanitario"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Vencimiento de registro sanitario</label>
                  <datepicker
                    :format="'dd/MM/yyyy'"
                    :bootstrap-styling="true"
                    v-model="current.vence_reg_sanitario"
                  ></datepicker>
                </div>
                <div class="col-6">
                  <br />
                  <label>Sku de articulo para reemplazar</label>
                  <input
                    type="text"
                    v-model="current.sku_reemplazar"
                    class="form-control"
                  />
                </div>
                <div class="col-6">
                  <br />
                  <label>Motivo de cambio</label>
                  <select v-model="current.motivo_cambio" class="form-control">
                    <option value="0">Nuevo</option>
                    <option value="1">Cambio de Tamaño</option>
                    <option value="2">Cambio Presentación</option>
                  </select>
                </div>
              </div>
              <div class="transition row" v-if="menu == '8'">
                <div class="col-4">
                  <label>Punta de gondola</label>
                  <input
                    type="text"
                    v-model="current.punta_de_gondola"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Media punta de gondola</label>
                  <input
                    type="text"
                    v-model="current.media_punta_gondola"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <label>Lateral isla</label>
                  <input
                    type="text"
                    v-model="current.laterial_isla"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Check out</label>
                  <input
                    type="text"
                    v-model="current.check_out"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Tiras cross</label>
                  <input
                    type="text"
                    v-model="current.tiras_cross"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Ofertero</label>
                  <input
                    type="text"
                    v-model="current.ofertero"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <br />
                  <label>Cantidad estante</label>
                  <input
                    type="text"
                    v-model="current.cantidad_en_estante"
                    class="form-control"
                  />
                </div>
                <div class="col-4">
                  <br />
                  <label>¿Estante por categoria? &nbsp;</label>
                  <input
                    type="checkbox"
                    v-model="current.estante_por_categoria"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="guardar(current)"
              type="button"
            >
              Guardar
            </button>
            &nbsp; &nbsp;
            <button
              class="btn btn-info"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import Notifications from "@/notifications/notifications";
import ProductosService from "@/services/catalogos/ProductosService";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      menu: "",
      marcas: [],
      datos: {
        tiendas: [],
      },
    };
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
    filtrartienda: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {},
  mounted() {
    this.refreshMarcarVehiculos();
  },
  methods: {
    guardar(current) {
      let self = this;
      var current = Object.assign({}, self.current);
      if (self.$route.params.sku) {
        current.id = self.$route.params.sku;
      }
      if (current.unidad_medida_compra) {
        current.unidad_medida_compra = current.unidad_medida_compra.id;
      }
      if (current.unidad_medida_solicitud) {
        current.unidad_medida_solicitud = current.unidad_medida_solicitud.id;
      }
      if (current.vence_reg_sanitario) {
        current.vence_reg_sanitario = moment(
          current.vence_reg_sanitario
        ).format("DD/MM/YYYY");
      }

      ProductosService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.pk = self.current.sku;
          self.current.errors = {};
          Notifications.alert.success(
            "Producto",
            "Se ha guardado la Información."
          );
          self.sku = res.data.pk;
          if (current.pk == null) {
            self.$router.push({
              name: "cat-productos-editar",
              params: { sku: self.current.sku },
            });
          }
          self.refresh();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
          });
        });
    },
    refreshMarcarVehiculos() {
      DynamicService.fetch("cat", "marcas").then((response) => {
        this.marcas = response.data.results;
      });
    },
  },
};
</script>
